module.exports = __webpack_public_path__ + "static/media/uit4.69f3fb95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/uit4.jpg
// module id = 189
// module chunks = 0